import { useNavigate, Link } from "react-router-dom";
import AnimarAlScroll from "../Animaciones/AnimarAlScroll";
import "./Footer.css";

function Footer() {
  const navigate = useNavigate();

  const _links = [
    { id: "inicio", label: "Inicio" },
    { id: "info-servicios", label: "Servicios" },
    { id: "galeria", label: "Galería" },
    { id: "sobre-cata", label: "Sobre Cata" },
    { id: "servicios", label: "Precios" },
  ];

  const navegarASeccion = (id) => {
    navigate("/");
    setTimeout(() => {
      const elemento = document.getElementById(id);
      if (elemento) {
        elemento.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  return (
    <footer className="footer">
      <AnimarAlScroll>
      <div className="contenedor">
        <div className="footer-contenido">
          <div className="footer-marca">
            <div className="footer-logo">
  <span className="footer-logo-principal">Glowroom</span>
  <span className="footer-logo-secundario">MVD</span>
</div>
            <p className="footer-descripcion">
              Estudio de uñas y pestañas profesional en Montevideo.
              Tu estilo. Tu esencia. Tu Glow.
            </p>
          </div>

          <div className="footer-links">
            <h4 className="footer-titulo-seccion">Navegación</h4>
            <ul className="footer-lista">
              {_links.map((link) => (
                <li key={link.id}>
                  <button
                    className="footer-link"
                    onClick={() => navegarASeccion(link.id)}
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-contacto">
            <h4 className="footer-titulo-seccion">Contacto</h4>
            <div className="footer-dato">
              <span>📍</span>
              <span>Montevideo, Uruguay</span>
            </div>
            <div className="footer-dato">
              <span>📱</span>
              <span>099 481 951</span>
            </div>
            <div className="footer-dato">
              <span>📸</span>
              <span>@glowroom.mvd</span>
            </div>
            <div className="footer-dato">
              <span>🕐</span>
              <span>Lun - Vie: 9:00 - 19:00</span>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-linea"></div>
          <div className="footer-bottom-contenido">
            <p className="footer-copyright">
              2025 Glowroom MVD. Todos los derechos reservados.
            </p>
            <p className="footer-credito">
              Hecho con amor por Victory & Solutions
            </p>
            <div className="footer-legales">
              <Link to="/privacidad" className="footer-link-legal">Privacidad</Link>
              <Link to="/terminos" className="footer-link-legal">Términos</Link>
            </div>
          </div>
        </div>
      </div>
      </AnimarAlScroll>
    </footer>
  );
}

export default Footer;